import { render, staticRenderFns } from "./addMemberTagging.vue?vue&type=template&id=6c5359f1"
import script from "./addMemberTagging.vue?vue&type=script&lang=js"
export * from "./addMemberTagging.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports